export const tipoTelefonesTypes = {
  CELULAR: 'Celular',
  DESCONHECIDO: 'Desconhecido',
  FAX: 'Fax',
  COMERCIAL: 'Comercial',
  RESIDENCIAL: 'Residencial',
};
